/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_TitleInputs */

const en_mk_tut_gl_title = /** @type {(inputs: Mk_Tut_Gl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glossary`)
};

const id_mk_tut_gl_title = /** @type {(inputs: Mk_Tut_Gl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamus istilah`)
};

/**
* | output |
* | --- |
* | "Glossary" |
*
* @param {Mk_Tut_Gl_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_title = /** @type {((inputs?: Mk_Tut_Gl_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_title(inputs)
	return en_mk_tut_gl_title(inputs)
});